export enum QuestionStateTypes {
  UNANSWERED = 1,
  ANSWERED = 2,
  INCORRECT = 3,
  CORRECT = 4
}
